import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import FacebookIcon from "@mui/icons-material/Facebook";
import LanguageIcon from "@mui/icons-material/Language"; // Use this for website icon
import { useCategories } from "@/hooks/useCategories";
const SiteFooter = () => {
  const { categories, loading, error } = useCategories();
  return (
    <footer className="bg-slate-50 text-slate-700 mt-16 border-t border-slate-100">
      <div className="container max-w-7xl mx-auto py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="font-display text-2xl text-slate-900">
            Kidilan
          </div>
          <p className="mt-3 text-sm text-slate-600">
            Premium travel gear designed for explorers. Built to endure.
            Designed to inspire.
          </p>
          <IconButton
            size="small"
            aria-label="instagram"
            component="a"
            href={import.meta.env.VITE_SOCIAL_INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            aria-label="youtube"
            component="a"
            href={import.meta.env.VITE_SOCIAL_YOUTUBE}
            target="_blank"
            rel="noopener noreferrer"
          >
            <YouTubeIcon fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            aria-label="facebook"
            component="a"
            href={import.meta.env.VITE_SOCIAL_FACEBOOK}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            aria-label="website"
            component="a"
            href={import.meta.env.VITE_SOCIAL_WEBSITE}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LanguageIcon fontSize="small" />
          </IconButton>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-3">Shop</div>
          <ul className="space-y-2 text-sm">
            {loading ? (
              <li>Loading categories...</li>
            ) : error ? (
              <li>Error loading categories.</li>
            ) : (
              categories?.map((cat) => (
                <li key={cat._id}>
                  <Link
                    to={`/shop?category=${cat._id}`}
                    className="hover:text-slate-900"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))
            )}
          </ul>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-3">Support</div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/order-tracking" className="hover:text-slate-900">
                Order Tracking
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-3">Contact</div>
          <ul className="space-y-2 text-sm">
            <li>
              Address: 69/3537, Safa Square, 1st Floor,Masjid Road, SRM Road, Ernakulam,
              Kochi 682018
            </li>
            <li>Phone: 9847065200</li>
            <li>Email: info@kidilan.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="container max-w-7xl mx-auto py-4 text-xs text-slate-500 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>
            © {new Date().getFullYear()} Kidilan Traveler. All rights reserved.
          </div>
          <div className="flex gap-4">
            <a className="hover:text-slate-700" href="#">
              Privacy
            </a>
            <a className="hover:text-slate-700" href="#">
              Terms
            </a>
            <a className="hover:text-slate-700" href="#">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
